<template>
  <div style="margin: 0 50px">
    <el-form :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="设备编号" label-width="120px">
        <span>{{row.deviceid}}</span>
      </el-form-item>
      <el-form-item v-if="isHome" label="所属家庭地址" label-width="120px">
        <span>{{row.h_address}}</span>
      </el-form-item>
      <el-row v-if="isHome">
        <el-col :span="12">
          <el-form-item label="安装位置" label-width="120px">
            <el-input style="width: 100%" v-model="addEditForm.installlocation" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备号码" label-width="120px" prop="phone">
            <el-input v-if="addEditForm.simcardno === ''" style="width: 100%" v-model="addEditForm.phone" autocomplete="off"></el-input>
            <el-input v-else style="width: 100%" disabled v-model="addEditForm.simcardno" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-else>
        <el-form-item v-if="!isHome" label="所属人员" label-width="120px">
          <span>{{row.p_name}}</span>
        </el-form-item>
        <el-form-item label="设备号码" label-width="120px" prop="phone">
          <el-input v-if="addEditForm.simcardno === ''" style="width: 400px" v-model="addEditForm.phone" autocomplete="off"></el-input>
          <el-input v-else style="width: 400px" disabled v-model="addEditForm.simcardno" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="row.devicetype !== 750" label="离线报警" label-width="120px" prop="phone">
          <el-switch
            v-model="addEditForm.nonetwork"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            active-text="开启"
            inactive-text="关闭">
          </el-switch>
        </el-form-item>
      </div>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAdd()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitEditDeive('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import { updatedevicetohome, updatedevicetoperson } from '../../../api/device'

export default {
  name: 'deviceEdit',
  model: {
    prop: 'editShow',
    event: 'change'
  },
  props: {
    deviceEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: {},
      orghomes: [],
      oldpersons: [],
      isEdit: false,
      isHome: true,
      addEditForm: {
        id: '',
        phone: '',
        installlocation: '',
        simcardno: '',
        nonetwork: '0'
      },
      addEditRules: {
        phone: [
          { required: true, message: '请输入设备号码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let dtypes = this.commonType.getWatchDtype()
      console.log(this.deviceEditRow)
      this.row = this.deviceEditRow.row
      this.orghomes = this.deviceEditRow.orghomes
      this.oldpersons = this.deviceEditRow.oldpersons
      if (dtypes.indexOf(this.row.devicetype) > -1) {
        this.addEditForm.phone = this.row.p_phone
        this.isHome = false
      } else {
        this.addEditForm.phone = this.row.h_phone
        this.addEditForm.installlocation = this.row.h_installlocation
        this.isHome = true
      }
      this.addEditForm.id = this.row.id
      this.addEditForm.simcardno = this.row.simcardno === '<nil>' ? '' : this.row.simcardno
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitEditDeive (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isHome) {
            let data = {
              id: this.addEditForm.id,
              phone: this.addEditForm.phone,
              installlocation: this.addEditForm.installlocation
            }
            updatedevicetohome(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功编辑设备',
                type: 'success',
                duration: 2000
              })
              this.$emit('getFatherEditDevice')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '编辑设备失败'
              })
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              phone: this.addEditForm.phone,
              nonetwork: parseInt(this.addEditForm.nonetwork)
            }
            updatedevicetoperson(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功编辑设备',
                type: 'success',
                duration: 2000
              })
              this.$emit('getFatherEditDevice')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '编辑设备失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/deviceEdit.vue